export const constructCourseDetails = ({
  year_published,
  default_year_level,
  curriculum,
  title,
  has_textbook,
  course_id,
}) => {
  return (
    `${year_published} - Y${default_year_level} - ${curriculum} - ` +
    `${title} - ${has_textbook ? '[Textbook]' : ''} - (id:${course_id})`
  );
};
